export const LEGAL_ASSIGNMENT: string = `

### <!--= ++sectionIndex -->. Assignment

We reserve the right to assign or transfer these Terms of Use, in whole or in part, and any of our rights or obligations under these Terms of Use at our discretion. This might occur, for example, if there is a change of ownership or in the event of a merger, acquisition, or sale of assets.

You are not entitled to assign these Terms of Use, in whole or in part, nor transfer or sub-license your rights under these Terms of Use, to any third party. Any attempted assignment or transfer in violation of the terms will be void and without effect.
`;
